import {useEffect, useState} from "react";

declare const FB: any;

export interface FbAuthResponse {
  accessToken: string;
  expiresIn: string;
  signedRequest: string;
  userID: string;
}

interface FbResponse {
  authResponse: FbAuthResponse | null;
  loginSource: any;
  status: 'unknown' | 'connected' | 'not_authorized'
}

export type handleFacebook = () => void
export type logout = () => void

export interface FacebookResponse {
  isLoading: boolean;
  isError: boolean;
  data: FbResponse | undefined;
  isSuccess: boolean
}

export const useFacebookLogin = (oauthFacebookClientId: string): [handleFacebook, FacebookResponse, logout] => {
  const [isSuccess, setSuccess] = useState<boolean>(false);
  const [isLoading, setLoading] = useState<boolean>(false);
  const [isError, setError] = useState<boolean>(false);
  const [data, setData] = useState<FbResponse | undefined>(undefined);
  const [clickCall, setClickCall] = useState(false)

  useEffect(() => {
    if (!oauthFacebookClientId) {
      console.error('facebook login not allowed.')
      return;
    }

    if (!(window as any).fbAsyncInit) {
      (window as any).fbAsyncInit = () => {
        FB.init({
          appId: oauthFacebookClientId,
          cookie: true,
          xfbml: true,
          version: 'v10.0'
        });

        FB.AppEvents.logPageView();
        console.log('first call. is already connected user?')
        FB.getLoginStatus(statusChangeCallback);
      };

    }


    (function (d, s, id) {
      var js: any, fjs: any = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));

  }, [oauthFacebookClientId])


  const handleClick = () => {
    setClickCall(true)
    setSuccess(false)
    setError(false)
    setLoading(true)
    setData(undefined)
    FB.login(statusChangeCallback, {scope: 'public_profile,email'});
  }

  const facebookLogout = () => {
    setLoading(true)
    FB.logout((response: any) => {
      console.log('logout facebook user', response);
      // Person is now logged out
      setLoading(false)
      setSuccess(true)
      setError(false)
    });
  }


  const statusChangeCallback = (response: FbResponse) => {  // Called with the results from FB.getLoginStatus().
    setLoading(false)
    if (!clickCall) {
      // do nothing for autologin
      return;
    }

    switch (response.status) {
      case "connected":
        console.info(' facebook connected. response: ', response);
        setSuccess(true)
        setError(false)
        setData(response)
        break;
      case "not_authorized":
        console.error('facebook user logged with facebook but not connected with store', response);
        setSuccess(false)
        setError(true)
        setData(response)
        break;
      case "unknown":
      default:
        console.error(' facebook not logged. response: ', response);
        setSuccess(false)
        setError(true)
        setData(response)
    }
  }


  return [handleClick, {
    isSuccess,
    isLoading,
    isError,
    data
  }, facebookLogout];
}
